export default "__VITE_PUBLIC_ASSET__51e436ab__"